import client from "./httpClient";
import * as apiConstants from "../constants/Api";
import { getErrorHandler, normalizeError } from "./apiErrorHandling";

const errorHandler = getErrorHandler({});

const handleNotesServiceError = async error => {
  const normalized = await normalizeError(error);
  errorHandler(normalized);
  // we can't stop execution even if error was handled so we rethrow
  throw normalized;
};

const baseUrl = `${apiConstants.SERVER_URL}/notes-service`;

export const fetchAllSecureNotes = async () => {
  return await client
    .get(`${baseUrl}/notes`)
    .json()
    .catch(handleNotesServiceError);
};

export const fetchCurrentNote = async id => {
  const note = await client
    .get(`${baseUrl}/notes/${id}`)
    .json()
    .catch(handleNotesServiceError);

  return note;
};

export const submitNewNote = async note => {
  return await client
    .post(`${baseUrl}/notes`, {
      json: { note }
    })
    .json()
    .catch(handleNotesServiceError);
};

export const updateCurrentNote = async note => {
  return await client
    .put(`${baseUrl}/notes/${note.id}`, {
      json: { note }
    })
    .json()
    .catch(handleNotesServiceError);
};

export const deleteCurrentNote = async id => {
  return await client
    .delete(`${baseUrl}/notes/${id}`)
    .json()
    .catch(handleNotesServiceError);
};

export const fetchCurrentNoteGrants = async id => {
  return await client
    .get(`${baseUrl}/grants/${id}`)
    .json()
    .catch(handleNotesServiceError);
};

export const updateCurrentNoteGrants = async (id, grants) => {
  return await client
    .put(`${baseUrl}/grants/${id}`, {
      json: { id, grants }
    })
    .json()
    .catch(handleNotesServiceError);
};
